import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'permission-review',
  templateUrl: './permission-review.component.html',
  styleUrls: ['./permission-review.component.scss']
})
export class PermissionReviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
